import { IDunningStepCreateSchema } from '@monetize/types/app';
import { convertEmailsStringToList } from '@monetize/types/common';

const convertEmailStringToArray = (
  value: IDunningStepCreateSchema['internalCCEmails'],
) => {
  if (!value) {
    return null;
  }

  const emails = convertEmailsStringToList(
    Array.isArray(value) ? value.join(',') : value,
  );

  return emails.length > 0 ? emails : null;
};

export const convertDunningRequestFromResponse = (
  step: IDunningStepCreateSchema,
): IDunningStepCreateSchema => ({
  ...step,
  internalCCEmails: convertEmailStringToArray(step.internalCCEmails),
  internalBCCEmails: convertEmailStringToArray(step.internalBCCEmails),
});
